import * as campaignColumns from 'modules/dashboard/components/dashboardWidget/widgets/campaignColumns';
import { campaignMediums, campaignStates } from 'utils/campaigns';
import { numberRangeThemes } from 'utils/themes';
import * as t from './dataTypes';
import * as c from './widgetSettings';

/**
 * baseChartSettings
 * Base config for all highcharts charts.
 * @param { String } xAxis: The x-axis title.
 * @param { String } yAxis: The y-axis title.
 * @returns { Object } The chart config.
 */
const baseChartSettings = (xAxis = '', yAxis = '') => ({
  xAxis: {
    title: { text: xAxis },
  },
  yAxis: {
    title: { text: yAxis },
  },
});

export const AREA = {
  name: 'area',
  getDataType: () => t.SERIES,
  getSettings: baseChartSettings,
  settingsList: [c.Y_AXIS],
};

export const BAR = {
  name: 'bar',
  getDataType: () => t.SERIES,
  getSettings: baseChartSettings,
  settingsList: [{ ...c.Y_AXIS, label: 'X-Axis Label' }],
};

export const CAMPAIGNS_TABLE = {
  name: 'campaignsTable',
  getDataType: () => t.CAMPAIGNS,
  getSettings: () => ({
    columns: [campaignColumns.NAME.value, campaignColumns.STATE.value],
    fetchParams: {
      page: 1,
      pageSize: 10,
      orderBy: 'id',
      sorting: 'desc',
      mediumFilter: campaignMediums.ALL.value,
      stateFilter: campaignStates.ALL.value,
    },
  }),
  settingsList: [c.CAMPAIGN_COLUMNS, c.CAMPAIGN_STATE, c.CAMPAIGN_MEDIUM],
};

export const COLUMN = {
  name: 'column',
  getDataType: () => t.SERIES,
  getSettings: baseChartSettings,
  settingsList: [c.Y_AXIS],
};

export const LINE = {
  name: 'line',
  getDataType: () => t.SERIES,
  getSettings: baseChartSettings,
  settingsList: [c.Y_AXIS],
};

export const MARKDOWN = {
  name: 'markdown',
  getDataType: () => t.MARKDOWN,
  getSettings: () => ({
    text: '',
  }),
  settingsList: [c.MARKDOWN_TEXT],
};

export const NUMBER = {
  name: 'number',
  getDataType: () => t.COMPARISON,
  settings: {},
  getSettings: () => ({
    invertColors: 0,
    rangeThresholds: [
      { color: '#eb144c', value: 0 },
      { color: '#fcb900', value: 50 },
      { color: '#00d034', value: 100 },
    ].slice(),
    showTrend: 1,
    rangeTheme: {
      customTheme: 0,
      reverse: false,
      themeName: numberRangeThemes.default.name,
      min: 0,
      max: 100,
    },
    trendDirection: 'up',
    trendColors: { up: '#00d034', down: '#eb144c' },
  }),
  settingsList: [
    c.TREND,
    c.TREND_DIRECTION,
    c.TREND_COLORS,
    c.NUMBER_RANGE,
    c.NUMBER_RANGE_THEME,
    c.NUMBER_RANGE_THRESHOLDS,
    c.INVERT_NUMBER_COLOR,
    c.SPARKLINE,
  ],
};

// Removing Pie for now until we have data that makes sense for it.
// export const PIE = {
//   name: 'pie',
//   chartConfig: baseWidgetSettings(),
//   getDataType: () => t.SERIES,
// };

export const PROGRESS = {
  name: 'progress',
  getSettings: baseChartSettings,
  getDataType: () => t.PERCENTAGE,
  settingsList: [],
};

export const RADIAL = {
  name: 'radial',
  getSettings: baseChartSettings,
  getDataType: () => t.PERCENTAGE,
  settingsList: [],
};

export const SPLINE = {
  name: 'spline',
  getDataType: () => t.SERIES,
  getSettings: baseChartSettings,
  settingsList: [c.Y_AXIS],
};

export const ALL = {
  name: 'all',
};

export const NUMBER_ALL = {
  name: 'number all',
  list: [AREA, BAR, COLUMN, LINE, NUMBER, SPLINE],
};

export const PERCENTAGE_ALL = {
  name: 'percentage all',
  list: [NUMBER, RADIAL, PROGRESS],
};
